import React, { useState, useEffect } from 'react';
import { navLinks } from '../mock';
import { Menu, X } from 'lucide-react';

const Logo = () => (
  <a href="#top" className="flex flex-col leading-none select-none">
    <span className="text-white font-black tracking-[0.18em] text-[22px] md:text-[26px]">
      LS<span className="text-[#e30613]">\</span>TOIT
    </span>
    <span className="text-[9px] md:text-[10px] tracking-[0.32em] text-white/60 mt-0.5">
      DACHY PŁASKIE
    </span>
  </a>
);

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled ? 'bg-black/85 backdrop-blur-md border-b border-white/5' : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-8 h-[78px] flex items-center justify-between gap-4">
        <Logo />
        <nav className="hidden xl:flex items-center gap-5">
          {navLinks.map((l) => (
            <a
              key={l.label}
              href={l.href}
              className="text-[10.5px] tracking-[0.12em] text-white/85 hover:text-white transition-colors duration-200 relative after:absolute after:left-0 after:-bottom-1 after:h-px after:w-0 after:bg-[#e30613] hover:after:w-full after:transition-all after:duration-300 whitespace-nowrap"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <a
          href="#kontakt"
          className="hidden xl:inline-flex items-center justify-center bg-[#e30613] hover:bg-[#c40510] text-white text-[11px] tracking-[0.18em] font-semibold px-5 py-3 transition-colors duration-200 whitespace-nowrap"
        >
          UMÓW OGLĘDZINY
        </a>
        <button
          aria-label="menu"
          className="xl:hidden text-white p-2"
          onClick={() => setOpen((v) => !v)}
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>
      {open && (
        <div className="xl:hidden bg-black/95 border-t border-white/5">
          <div className="px-6 py-6 flex flex-col gap-5">
            {navLinks.map((l) => (
              <a
                key={l.label}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-[12px] tracking-[0.14em] text-white/85 hover:text-white"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#kontakt"
              onClick={() => setOpen(false)}
              className="inline-flex items-center justify-center bg-[#e30613] text-white text-[12px] tracking-[0.2em] font-semibold px-6 py-3 mt-2"
            >
              UMÓW OGLĘDZINY
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
